"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBTourTooltip = require("./HBTourTooltip.styles");
var _Lightbulb = _interopRequireDefault(require("@honeybook/icons/dist/icons/Lightbulb24"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBTourTooltip = function HBTourTooltip(_ref) {
  var title = _ref.title,
    description = _ref.description,
    joyrideProps = _ref.joyrideProps,
    horizontalOffset = _ref.horizontalOffset,
    verticalOffset = _ref.verticalOffset,
    imgUrl = _ref.imgUrl,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    _ref$CtaButtonText = _ref.CtaButtonText,
    CtaButtonText = _ref$CtaButtonText === void 0 ? 'Next' : _ref$CtaButtonText,
    extraContent = _ref.extraContent;
  var tooltipProps = joyrideProps.tooltipProps,
    onCloseClick = joyrideProps.skipProps.onClick,
    onNextClick = joyrideProps.primaryProps.onClick,
    onBackClick = joyrideProps.backProps.onClick,
    _joyrideProps$step = joyrideProps.step,
    stepIndex = _joyrideProps$step.stepIndex,
    stepCounter = _joyrideProps$step.stepCounter;
  var handleUserKeyPress = (0, _react.useCallback)(function (event) {
    var key = event.key;
    if (key === 'Enter') {
      onNextClick(event);
    }
  }, [onNextClick]);
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', handleUserKeyPress);
    return function () {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  }, [handleUserKeyPress]);
  return /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.Container, (0, _extends2["default"])({}, tooltipProps, {
    verticalOffset: verticalOffset,
    horizontalOffset: horizontalOffset,
    id: "tooltip_container"
  }), extraContent, showCloseButton && /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.TourActionsContainer, null, stepIndex !== 1 && /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.StyledArrowIcon, {
    onClick: onBackClick,
    color: _colors["default"].neutral600,
    "data-testid": "tour-back--button"
  }), /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.StyledCloseIcon, {
    onClick: onCloseClick,
    color: _colors["default"].neutral600,
    "data-testid": "tour-close--button"
  })), /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.InnerContainer, null, imgUrl && /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.StyledGIF, {
    src: imgUrl
  }), /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.Header, null, /*#__PURE__*/_react["default"].createElement(_Lightbulb["default"], {
    useDefaultFill: true
  }), /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.Title, {
    type: "Emphasis-Medium"
  }, title)), /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.Description, {
    type: "Body-Small"
  }, description), /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.Footer, null, /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.NextButton, {
    id: "tour_next_button",
    testId: "tour-next--button",
    onClick: onNextClick,
    customTheme: {
      background: _colors["default"].blue20,
      hoverBackgroundColor: _colors["default"].blue25
    }
  }, CtaButtonText), stepIndex && /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.StepCounter, null, stepIndex, " of ", stepCounter))));
};
var _default = exports["default"] = HBTourTooltip;
//# sourceMappingURL=HBTourTooltip.js.map